import React from 'react'
import _ from 'lodash'


import {TravelSearchItem} from './travelsearchitem.component.js'

export class TravelSearchResults extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        let formattedResults = this.props.results.map((item, index) => {
            return <TravelSearchItem 
      key={index} 
      result={item} 
      maxDuration={this.props.maxDuration} 
      addTransportation={this.props.addTransportation} 
      onRemoveTransportation = {this.props.onRemoveTransportation}
      activateSearchItem={this.props.activateSearchItem}
      deActivateSearchItem={this.props.deActivateSearchItem}
      getDuration={this.props.getDuration}
      transportation={this.props.transportation}/>
        })
        return	<div>{formattedResults}</div>
    }
}